(function() {
    'use strict';

    angular.module('doclr.components.colorselector', [])
        .directive('doclrColorSelector', function () {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    disabled: '=',
                    selectedColor: '='
                },
                template: '<div class="colorpicker dropdown">' +
                            '<button type="button" class="colorpicker-button btn btn-default dropdown-toggle" type="button" ng-style="{\'background-color\': selectedColor}" data-toggle="dropdown" ng-disabled="disabled" ng-class="{disabled : disabled}" aria-haspopup="true" aria-expanded="true">' +
                                '<span class="caret"></span>' +
                            '</button>' +
                            '<ul class="colorpicker-colors dropdown-menu" role="menu">' +
                                '<li ng-repeat="color in colors" class="colorpicker-color">' +
                                    '<a ng-click="changeSelectedColor(color)" ng-class="{selected : selectedColor === color}" ng-style="{ \'background-color\': color }">&nbsp;</a>' +
                                '</li>' +
                            '</ul>' +
                          '</div>',
                link: function(scope) {
                    scope.colors = ['#bee0f9', '#ffee90', '#a1e993', '#e68c8c', '#d8bff2', '#c4c4c4', '#e4e4e4', '#ffb6c1', '#ffa07a', '#f2f5f5', '#8ddff2', '#57ccd9', '#58bfb0', '#d6bf6f', '#d696b5'];

                    scope.changeSelectedColor = function(color) {
                        scope.selectedColor = color;
                    };
                }
            };
        });
})();